// [EDITED: KPI Task - Mahesh Sharma]
/**
 * KPISection Component
 * Reusable component for displaying KPI data in a table with sub-tabs, week selection,
 * search filtering, PDF/Excel export, and action buttons.
 */
import React, { useState, useMemo } from 'react'; // [EDITED: KPI Task - Mahesh Sharma]
import PropTypes from 'prop-types'; // [EDITED: KPI Task - Mahesh Sharma]
import FYWeekPicker from '../../components/FYWeekPicker'; // [EDITED: KPI Task - Mahesh Sharma]
import { formatFYWeekLabel } from '../../utils/fyWeekUtils'; // [EDITED: KPI Task - Mahesh Sharma]
import { exportKPIToExcel, exportKPIToPDF } from '../../utils/kpiReportExport'; // [EDITED: KPI Task - Mahesh Sharma]

const KPISection = ({ // [EDITED: KPI Task - Mahesh Sharma]
  title, // [EDITED: KPI Task - Mahesh Sharma]
  week, // [EDITED: KPI Task - Mahesh Sharma]
  onWeekChange, // [EDITED: KPI Task - Mahesh Sharma]
  data = [], // [EDITED: KPI Task - Mahesh Sharma]
  loading = false, // [EDITED: KPI Task - Mahesh Sharma]
  columns, // [EDITED: KPI Task - Mahesh Sharma]
  dataKeys, // [EDITED: KPI Task - Mahesh Sharma]
  onRowClick, // [EDITED: KPI Task - Mahesh Sharma]
  tabs = [], // [EDITED: KPI Task - Mahesh Sharma]
  activeTab = '', // [EDITED: KPI Task - Mahesh Sharma]
  onTabChange, // [EDITED: KPI Task - Mahesh Sharma]
  showExport = true, // [EDITED: KPI Task - Mahesh Sharma]
  onRevokeRating, // [EDITED: KPI Task - Mahesh Sharma]
  userRole = '', // [EDITED: KPI Task - Mahesh Sharma]
}) => { // [EDITED: KPI Task - Mahesh Sharma]
  const [searchTerm, setSearchTerm] = useState(''); // [EDITED: KPI Task - Mahesh Sharma]

  // Filter data based on search term // [EDITED: KPI Task - Mahesh Sharma]
  const filteredData = useMemo(() => { // [EDITED: KPI Task - Mahesh Sharma]
    if (!searchTerm.trim()) return data; // [EDITED: KPI Task - Mahesh Sharma]
    const term = searchTerm.toLowerCase(); // [EDITED: KPI Task - Mahesh Sharma]
    return data.filter((item) => // [EDITED: KPI Task - Mahesh Sharma]
      Object.values(item).some( // [EDITED: KPI Task - Mahesh Sharma]
        (val) => val && String(val).toLowerCase().includes(term) // [EDITED: KPI Task - Mahesh Sharma]
      ) // [EDITED: KPI Task - Mahesh Sharma]
    ); // [EDITED: KPI Task - Mahesh Sharma]
  }, [data, searchTerm]); // [EDITED: KPI Task - Mahesh Sharma]

  const handleExportExcel = () => { // [EDITED: KPI Task - Mahesh Sharma]
    exportKPIToExcel(filteredData, week, `${title} Tracker`); // [EDITED: KPI Task - Mahesh Sharma]
  }; // [EDITED: KPI Task - Mahesh Sharma]

  const handleExportPDF = () => { // [EDITED: KPI Task - Mahesh Sharma]
    exportKPIToPDF(filteredData, week, `${title} Tracker`); // [EDITED: KPI Task - Mahesh Sharma]
  }; // [EDITED: KPI Task - Mahesh Sharma]

  return ( // [EDITED: KPI Task - Mahesh Sharma]
    <div className="kpi-section" style={{ background: '#fff', borderRadius: '12px', boxShadow: '0 2px 10px rgba(0,0,0,0.06)', padding: '1rem', marginBottom: '1.5rem' }}>
      {/* Card Header */}
      <div className="kpi-section__header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'nowrap', gap: '0.6rem', marginBottom: '1rem' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
          <h2 className="kpi-section__title" style={{ fontSize: '1.2rem', fontWeight: '700', color: '#1e293b', margin: 0 }}>
            {title}
          </h2>
          {!loading && (
            <span className="kpi-section__count-badge" style={{ background: '#e0f2fe', color: '#0369a1', padding: '0.2rem 0.6rem', borderRadius: '20px', fontSize: '0.8rem', fontWeight: '700' }}>
              {filteredData.length}
            </span>
          )}
        </div>

        {/* Week Selector & Export Actions */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', flexWrap: 'nowrap', flexShrink: 0 }}>
          <div className="kpi-section__inline-week">
            <FYWeekPicker
              size="sm"
              value={week}
              onChange={onWeekChange}
              style={{ minWidth: '210px' }}
            />
          </div>

          {showExport && (
            <div className="btn-group btn-group-sm">
              <button
                type="button"
                className="btn btn-outline-success"
                onClick={handleExportExcel}
                title="Download Excel Report"
                aria-label="Download Excel Report"
                disabled={loading || filteredData.length === 0}
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0.3rem 0.55rem' }}
              >
                <i className="bi bi-file-earmark-excel"></i>
              </button>
              <button
                type="button"
                className="btn btn-outline-danger"
                onClick={handleExportPDF}
                title="Download PDF Report"
                aria-label="Download PDF Report"
                disabled={loading || filteredData.length === 0}
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0.3rem 0.55rem' }}
              >
                <i className="bi bi-file-earmark-pdf"></i>
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Sub-tabs for Submitted/Not Submitted or Rated/Not Rated */}
      {tabs.length > 0 && (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #e2e8f0', marginBottom: '1rem', paddingBottom: '0.5rem', flexWrap: 'wrap', gap: '0.5rem' }}>
          <div style={{ display: 'flex', gap: '0.5rem' }}>
            {tabs.map((tab) => {
              const isActive = activeTab === tab.id;
              return (
                <button
                  key={tab.id}
                  type="button"
                  onClick={() => onTabChange && onTabChange(tab.id)}
                  className={`btn btn-sm ${isActive ? 'btn-primary' : 'btn-light'}`}
                  style={{
                    borderRadius: '20px',
                    padding: '0.28rem 0.7rem',
                    fontSize: '0.72rem',
                    fontWeight: isActive ? '600' : '500',
                    transition: 'all 0.2s ease',
                  }}
                >
                  {tab.label} {tab.count !== undefined && <span className={`badge ms-1 ${isActive ? 'bg-white text-primary' : 'bg-secondary'}`} style={{ fontSize: '0.62rem' }}>{tab.count}</span>}
                </button>
              );
            })}
          </div>

          {/* Quick Search */}
          <div style={{ width: '200px' }}>
            <input
              type="text"
              placeholder="Search..."
              className="form-control form-control-sm"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{ fontSize: '0.75rem', borderRadius: '6px' }}
            />
          </div>
        </div>
      )}

      {/* Table */}
      <div className="kpi-section__table-wrapper">
        <table className="kpi-section__table table table-hover" style={{ width: '100%', marginBottom: 0 }}>
          <thead style={{ background: '#f8fafc' }}>
            <tr>
              <th className="kpi-section__th kpi-section__th--sno" style={{ width: '40px', padding: '10px' }}>#</th>
              {columns.map((column, index) => (
                <th key={index} className="kpi-section__th" style={{ padding: '10px', color: '#475569', fontWeight: '600' }}>
                  {column}
                </th>
              ))}
              {onRevokeRating && <th className="kpi-section__th" style={{ padding: '10px', textAlign: 'center' }}>Action</th>}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={columns.length + (onRevokeRating ? 2 : 1)} className="kpi-section__state-cell" style={{ textAlign: 'center', padding: '2rem' }}>
                  <div className="kpi-section__loading-state" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem', color: '#64748b' }}>
                    <span className="spinner-border spinner-border-sm" role="status"></span>
                    <span>Loading KPI data...</span>
                  </div>
                </td>
              </tr>
            ) : filteredData.length === 0 ? (
              <tr>
                <td colSpan={columns.length + (onRevokeRating ? 2 : 1)} className="kpi-section__state-cell" style={{ textAlign: 'center', padding: '2rem' }}>
                  <div className="kpi-section__empty-state" style={{ color: '#94a3b8' }}>
                    <span style={{ fontSize: '1.5rem', display: 'block', marginBottom: '0.25rem' }}>📋</span>
                    <span>No records found for this period</span>
                  </div>
                </td>
              </tr>
            ) : (
              filteredData.map((item, index) => (
                <tr
                  key={item.id || item.kpi_id || index}
                  className={`kpi-section__row ${index % 2 === 0 ? 'kpi-section__row--even' : 'kpi-section__row--odd'}`}
                  style={{ cursor: onRowClick ? 'pointer' : 'default' }}
                  onClick={() => onRowClick && onRowClick(item)}
                >
                  <td className="kpi-section__td kpi-section__td--sno" style={{ padding: '10px', color: '#64748b' }}>{index + 1}</td>
                  {dataKeys.map((key, keyIndex) => (
                    <td key={keyIndex} className="kpi-section__td" style={{ padding: '10px' }}>
                      {key === 'role' || key === 'reviewer_role' || key === 'employee_role' ? (
                        <span className="badge bg-light text-dark border">{item[key]?.toUpperCase() || 'N/A'}</span>
                      ) : key === 'submission_status' ? (
                        <span className={`badge ${item[key] === 'Submitted' ? 'bg-success' : 'bg-danger'}`}>
                          {item[key]}
                        </span>
                      ) : key === 'rating_status' ? (
                        <span className={`badge ${item[key] === 'Rated' ? 'bg-success' : 'bg-warning text-dark'}`}>
                          {item[key]}
                        </span>
                      ) : key === 'pending_count' ? (
                        <span
                          className="badge bg-primary"
                          style={{ cursor: 'pointer', padding: '0.35rem 0.65rem' }}
                          title="Click to view pending submissions"
                        >
                          {item[key]} Pending
                        </span>
                      ) : (
                        item[key] !== undefined && item[key] !== null ? String(item[key]) : '-'
                      )}
                    </td>
                  ))}
                  {onRevokeRating && (
                    <td style={{ textAlign: 'center', padding: '8px' }}>
                      {(item.rating_status === 'Rated' || item.TLPoints || item.hod_points) && (
                        <button
                          type="button"
                          className="btn btn-outline-danger btn-sm"
                          onClick={(e) => {
                            e.stopPropagation();
                            onRevokeRating(item.id || item.kpi_id || item.employee_id);
                          }}
                          style={{ fontSize: '0.75rem', padding: '0.2rem 0.5rem' }}
                          title="Revoke rating and reopen for evaluation"
                        >
                          <i className="bi bi-arrow-counterclockwise me-1"></i> Revoke
                        </button>
                      )}
                    </td>
                  )}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Footer */}
      {!loading && filteredData.length > 0 && (
        <div className="kpi-section__footer" style={{ marginTop: '0.75rem', fontSize: '0.8rem', color: '#64748b', display: 'flex', justifyContent: 'space-between' }}>
          <span>Showing <strong>{filteredData.length}</strong> records</span>
          <span style={{ fontStyle: 'italic' }}>{formatFYWeekLabel(week)}</span>
        </div>
      )}
    </div>
  );
};

KPISection.propTypes = { // [EDITED: KPI Task - Mahesh Sharma]
  title: PropTypes.string.isRequired, // [EDITED: KPI Task - Mahesh Sharma]
  week: PropTypes.string.isRequired, // [EDITED: KPI Task - Mahesh Sharma]
  onWeekChange: PropTypes.func.isRequired, // [EDITED: KPI Task - Mahesh Sharma]
  data: PropTypes.arrayOf(PropTypes.object), // [EDITED: KPI Task - Mahesh Sharma]
  loading: PropTypes.bool, // [EDITED: KPI Task - Mahesh Sharma]
  columns: PropTypes.arrayOf(PropTypes.string).isRequired, // [EDITED: KPI Task - Mahesh Sharma]
  dataKeys: PropTypes.arrayOf(PropTypes.string).isRequired, // [EDITED: KPI Task - Mahesh Sharma]
  onRowClick: PropTypes.func, // [EDITED: KPI Task - Mahesh Sharma]
  tabs: PropTypes.arrayOf(PropTypes.object), // [EDITED: KPI Task - Mahesh Sharma]
  activeTab: PropTypes.string, // [EDITED: KPI Task - Mahesh Sharma]
  onTabChange: PropTypes.func, // [EDITED: KPI Task - Mahesh Sharma]
  showExport: PropTypes.bool, // [EDITED: KPI Task - Mahesh Sharma]
  onRevokeRating: PropTypes.func, // [EDITED: KPI Task - Mahesh Sharma]
  userRole: PropTypes.string, // [EDITED: KPI Task - Mahesh Sharma]
}; // [EDITED: KPI Task - Mahesh Sharma]

export default KPISection; // [EDITED: KPI Task - Mahesh Sharma]
